<template>
  <div class="col-big-vbspace basic-form">
    <div
      class="col-vspace flex-radio"
      :class="active !== 'list' ? 'flex-radio--disabled' : false"
    >
      <div class="flex-radio__input">
        <input
          type="radio"
          name="type-choice"
          value="list"
          id="type-choice-list"
          v-model="active"
        />
        <label
          for="type-choice-list"
          class="flex-radio__input__box"
        ></label>
      </div>

      <div class="flex-radio__data">
        <label class="label--textarea" for="choice-list">
          Je choisis dans la liste
        </label>

        <select
          name="choice-list"
          id="choice-list"
          class="classic-select tcenter"
          v-model="selectMessage"
          @focus="focusSelect"
        >
          <option value="">CHOISISSEZ ICI ...</option>
          <option
            v-for="(option, index) in options"
            :value="option.value"
            :key="index"
          >
            {{ option.value }}
          </option>
        </select>
      </div>
    </div>

    <p class="big-title bold">OU</p>

    <div
      class="col-vspace flex-radio"
      :class="active !== 'own' ? 'flex-radio--disabled' : false"
    >
      <div class="flex-radio__input">
        <input
          type="radio"
          name="type-choice"
          value="own"
          id="type-choice-own"
          v-model="active"
          @focus="focusInput"
        />
        <label
          for="type-choice-own"
          class="flex-radio__input__box"
        ></label>
      </div>
      <div class="flex-radio__data">
        <label class="label--textarea" for="choice-list">
          Je crée mon idée géniale (max. {{maxLength}} caractères)
        </label>

        <input
          type="text"
          class="classic-input tupper"
          v-model="innerMessage"
          :maxlength="maxLength"
          @focus="focusInput"
          @blur="backName"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    maxLength: {
      type: Number,
      default: 20,
    },
    message: {
      type: String,
      default: 'Mon idée géniale',
    },
    options: {
      type: Array,
      default: () => [
        { value: 'EST LA MEILLEURE' },
        { value: 'EST LE MEILLEUR' },
        { value: '2023 MON 1ER NOËL' },
        { value: '2023 MON 2E NOËL' },
        { value: '2023 MON 3E NOËL' },
        { value: 'JOYEUX NOËL 2023' },
        { value: 'ME FAIT RÊVER' },
        { value: 'EST MON IDOLE' },
        { value: 'EST MA PRÉFÉRÉE' },
        { value: 'EST MON PRÉFÉRÉ' },
        { value: 'EST UNE DÉESSE' },
        { value: 'EST UN DIEU' },
        { value: 'MERVEILLEUX NOËL' },
        { value: 'JOYEUX NOËL PAPY' },
        { value: 'JOYEUX NOËL MAMY' },
        { value: "J'AI ÉTÉ SAGE" },
      ],
    },
  },

  data() {
    return {
      active: 'list',
      default: '',
      selectMessage: '',
    };
  },

  created() {
    this.default = this.message;
  },

  watch: {
    selectMessage() {
      this.changeName();
    },

    active() {
      this.$emit(
        'change-name',
        this.active === 'list' ? this.selectMessage : this.innerMessage,
      );
    },
  },

  computed: {
    innerMessage: {
      get() {
        return this.message;
      },
      set(newValue) {
        this.$emit('change-name', newValue.toUpperCase());
      },
    },
  },

  methods: {
    resetName() {
      if (this.message === this.default) {
        this.$emit('change-name', '');
      }
    },
    backName() {
      if (this.message === '') {
        this.$emit('change-name', this.default);
      }
    },

    changeName() {
      this.default = this.selectMessage;
      this.$emit('change-name', this.selectMessage);
    },

    focusInput() {
      this.active = 'own';
      this.resetName();
    },

    focusSelect() {
      this.active = 'list';
    },
  },
};
</script>
